import axios from 'axios';
import { IFormation } from '../types/formations';

const getFormation = async (id: string | undefined) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/formations/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.formation;
};

const getUserFormations = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/formations/user`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.formations;
};

const getFormationsList = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/formations/list`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.list;
};

const createFormation = async (data: Partial<IFormation>)
: Promise<{ formation: IFormation }> => {
  const token = localStorage.getItem('token');

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/formations`,
    data,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return response.data;
};

// eslint-disable-next-line max-len
const updateFormation = async (data: Partial<IFormation>)
: Promise<{ formation: IFormation }> => {
  const token = localStorage.getItem('token');
  const { _id, ...updatedData } = data;
  console.log(data);
  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}/formations/${_id}`,
    updatedData,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

const duplicateFormation = async (id?: string | null) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/formations/duplicate/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.formation;
};

const deleteFormation = async (id: string)
: Promise<{ formation: IFormation }> => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/formations/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export {
  getFormation,
  getUserFormations,
  createFormation,
  updateFormation,
  duplicateFormation,
  deleteFormation,
  getFormationsList,
};
